import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import getFechaSinHora from '@helpers/dates/getDateFinalizacionCurso/getFechaSinHora'
import { MaterialReactTable } from 'material-react-table'
import { MRT_Localization_ES } from 'material-react-table/locales/es'
import React, { useMemo, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'


const RegistroUsuarios = ({setShowRegistro, colaboradores, adminForo, usuarioLogeado}) => {

    const columnas = useMemo(() => [
            // {
            //     accessorFn: (row) => (`${row.codigoRegion}-${row.folioContrato}`),
            //     header: "Folio",
            //     size: 50,
            // },
            {
                accessorKey: "nombreCompleto",
                header: "Nombre",
            },
            {
                accessorKey: "apellidos",
                header: "Apellidos",
            },
           
            {
                accessorKey: "correo",
                header: "Correo",
            },
             {
                accessorFn: (row) => getFechaSinHora(row.fechaRegistro),
                header: "Fecha de registro",
            },

             {
                accessorKey: "matricula",
                header: "Matricula",
            },
             {
                accessorKey: "grado",
                header: "Grado",
            },

             {
                accessorKey: "plantel",
                header: "Plantel",
            },
             {
                accessorKey: "municipio",
                header: "Municipio",
            },

             {
                accessorKey: "nombreDocente",
                header: "Responsable",
            },

             {
                accessorKey: "correoDocente",
                header: "Correo del responsable",
            },
           
            {
                accessorFn: (row) => (row.estatusCredencial === 1 ? "Activo" : "Ináctivo"),
                // accessorKey: "estatusCredencial",
                header: "Estado",
                // size: 50,
            },
        ]);

         // 👇 Filtro inicial si el usuario no es admin
        const [columnFilters, setColumnFilters] = useState(
            !adminForo
            ? [
                {
                    id: 'correoDocente', // <- columna por la que filtras
                    value: usuarioLogeado.correo, // <- valor a filtrar
                },
                ]
            : []
        );

    return (
        <Container fluid className="mb-5 pb-5" style={{ minHeight: '60vh' }}>
            <Row className="mt-4 mb-3">
                <Col className='d-flex flex-row justify-content-between align-items-center'>
                    <h2>Usuarios ya registrados en el curso</h2>
                    <Button onClick={() => setShowRegistro(false)} className="mb-3 btn btn-danger"><FontAwesomeIcon icon={faClose} size='lg' /></Button>
                </Col>
            </Row>

            <Row className="mt-5 mb-5">
                <Col>
                <p><small>Utilíza <code>shift + rueda del mouse</code> sobre los registros para ver toda la información</small></p>

                    <MaterialReactTable
                        localization={MRT_Localization_ES}
                        columns={columnas}
                        data={colaboradores}
                       state={{
                            columnFilters, // <- estado controlado del filtro
                        }}
                        onColumnFiltersChange={setColumnFilters} // <- importante para MRT v2
                        enableColumnFilters={adminForo} // los no admin no pueden cambiar filtros
                        enableGlobalFilter={adminForo} // los no admin no pueden buscar globalmente
                        enableSorting
                        enableColumnActions={adminForo}
                        enableFilterMatchHighlighting={false}
                        // enableRowActions
                        // positionActionsColumn="last"
                        // renderRowActions={({ row, table }) => (
                        //     <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                        //         <IconButton color="primary" onClick={handleMenuSelection} id={row.original.idPersona}>
                        //             <MenuIcon />
                        //         </IconButton>
                        //     </Box>
                        // )}
                    />
                </Col>
                
            </Row>
        </Container>
    )
}

export default RegistroUsuarios